exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mobile-wrapper{position:absolute;justify-content:center;height:100%;width:100%;top:0;left:0;background-color:#fff;overflow:hidden}.mobile-wrapper .content-wrapper{width:100%;height:calc(100% - 48px);position:relative}.content-wrapper::-webkit-scrollbar{display:none}#root{height:100%;width:100%;overflow:hidden}body{top:0;user-select:auto;-webkit-tap-highlight-color:transparent!important}@media only screen and (min-device-width:320px) and (max-device-width:480px){body{background-color:#000;position:absolute;left:0;width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/mobileWrappers/MobileWrapper.scss
// module id = 1867
// module chunks = 0